import { useContext } from 'react';

import {
  CountryCodeContext,
  CountryCodeFromServerContext,
} from '@/shared/contexts';

/**
 * @description
 * - 국가코드를 서버사이드에서 먼저 가져오도록 하고, 없으면 클라이언트에서 조회
 * - ⚠️ 클라이언트에서 사용 시 hydration error를 일으킬 수 있습니다. 그럴 경우 NoSSR로 감싸 사용하세요.
 */

export function useCountryCode() {
  const serverContext = useContext(CountryCodeFromServerContext);
  const clientContext = useContext(CountryCodeContext);

  if (serverContext) {
    return {
      countryCode: serverContext.countryCode,
      // 서버(getServerSideProps)가 산출한 값은 실제 출처 → resolved 로 취급.
      resolvedCountryCode: serverContext.countryCode,
      isKR: serverContext.countryCode === 'KR',
      isReady: true,
      isLoading: false,
    };
  }
  if (clientContext) {
    return clientContext;
  }

  throw new Error(
    'useCountryCode must be used within either CountryCodeProvider or CountryCodeFromServerProvider',
  );
}
